import { useContext } from "react";

import { AlertDialogProvider } from "./alert-dialog-component.context.lib";
import { AlertDialogContext } from "./alert-dialog.context.lib";

const useAlertDialogContext = () => useContext(AlertDialogContext);

export default AlertDialogProvider;
export { useAlertDialogContext };
